import React from 'react';
import {
  string, shape, object,
} from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import Locale from '@active/react-utils/i18n/Locale';
import AddressStatic from '@active/react-address-editor/components/AddressStatic';

const AddressInfo = ({ addressInfo, title }) => {
  if (isEmpty(addressInfo)) {
    return null;
  }
  const {
    firstName, lastName, address = {}, email, phoneNumber,
  } = addressInfo;

  return (
    <div className="payment-address-info">
      <div className="payment-address-info-title" >
        <Locale id={title} />
      </div>
      <div className="payment-address-info-content" >
        {
          firstName && lastName
        && <div className="address-info-content__name">
          <div className="address-info-content__name-first">{firstName}</div>
          <div className="address-info-content__name-last">{lastName}</div>
        </div>
        }
        <div className="address-info-content__address">
          <AddressStatic address={address} />
        </div>
        {email && <div className="address-info-content__email">
          {email}
        </div>
        }
        {phoneNumber && <div className="address-info-content__phoneNumber">
          {phoneNumber}
        </div>
        }
      </div>
    </div>
  );
};

AddressInfo.propTypes = {
  addressInfo: shape({
    firstName: string,
    lastName: string,
    address: object,
    email: string,
  }),
  title: string,
};

export default AddressInfo;
